import { ReactNode } from "react";

interface MainWrapperProps {
  children: ReactNode;
  id: string;
}

export const MainWrapper = ({ children, id }: MainWrapperProps) => {
  //const isStaging = !import.meta.env.RENDER;
  return (
    <div
      id={id}
      className={`flex flex-col bg-yally-fine font-normal text-foreground`}
    >
      {children}
    </div>
  );
};
